import LoadPanel from 'app/components/LoadPanel';
import { NotFoundPage } from 'app/components/NotFoundPage';
import { WrapContent } from 'app/components/WrapContent';
import useAxios from 'axios-hooks';
import { PACKAGE_TP } from 'constant';
import useDictionary from 'hooks/useDictionary';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { notification } from 'utils/notification';

const CompanyInfo = React.lazy(() => import('./CompanyInfo'));
const EditCompany = React.lazy(() => import('./Edit'));

/**
 * create context
 */
const ModuleContext = createContext({});
ModuleContext.displayName = 'CompanyManager_Context';
export const useModuleContext = () => {
  return useContext(ModuleContext);
};

const CompanyManager = () => {
  const { t }: any = useDictionary({ programId: 'company-manager' });
  const [data, setData] = useState([]);
  const [modeView, setModeView] = useState({
    type: 'info',
    data: null,
  });

  const [{ loading }, refetchData] = useAxios(
    {},
    { manual: true, autoCancel: true, useCache: false },
  );

  useEffect(() => {
    onSubmit();
  }, []);

  /**
   * on submit
   *
   */
  const onSubmit = async () => {
    const res = await refetchData({
      url: '/user-company/user-get-detail',
      method: 'GET',
    });
    if (res?.data?.status === '200') {
      (res?.data?.data || {})?.services?.forEach(o => ({
        ...o,
        packageTpNm: PACKAGE_TP?.[o.packageTp]?.text,
      }));
      setData(res?.data?.data || {});
    } else {
      notification({ res });
    }
  };

  const value: any = {
    t,
    data,
    setData,
    modeView,
    setModeView,
    onSubmit,
  };

  /**
   * render content
   *
   * @return {*}
   */
  const renderContent = () => {
    switch (modeView?.type) {
      case 'info':
        return <CompanyInfo />;
      case 'edit':
        return <EditCompany />;
      default:
        return <NotFoundPage />;
    }
  };

  return (
    <WrapContent>
      <ModuleContext.Provider value={value}>
        <React.Suspense fallback={<LoadPanel visible={true} />}>
          <LoadPanel visible={loading} />
          {renderContent()}
        </React.Suspense>
      </ModuleContext.Provider>
    </WrapContent>
  );
};

export default CompanyManager;
